import {useCallback, useEffect, useState} from "react";
import {KompetenceCard} from "./kompetenceCard";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {useAppDispatch, useAppSelector} from "app/hooks";
import {forloebReducer, ForloebSliceState} from "core/forloebSlice";
import {
    clearSelectedLaegekompetenceMetas,
    kompetenceCardReducer,
    KompetenceCardState,
    LaegekompetenceMetaState,
    setKompetenceCardStateShowCheckboxes,
    toggleLaegekompetenceListRefreshPing,
    toggleLaegekompetenceNotatChangedPing
} from "./kompetenceCardSlice";
import {EmblaIcon} from "../../../core/components/emblaIcon/emblaIcon";
import {LaegekompetenceMeta} from "../../../core/sharedmodels/kompetence/laegekompetenceMeta";
import {setSlideinState, SlideInStateEnum} from "core/components/slideIn/slideInSlice";
import {KompetenceStatusButton} from "core/componentsPage/kompetence/kompetenceStatusButton";
import {CollapseHeaderTypeEnum, CollapseTab} from "core/components/Tabs/collapseTab";
import "./kompetenceCardList.scss"
import {useLocation} from "react-router-dom";
import {NotificationModule} from "ditmer-embla";
import {SlideIn} from "../../../core/components/slideIn/slideIn";
import {
    CreateLaegekompetenceNotat
} from "../../../core/componentsPage/notat/kompetenceNotat/createLaegekompetenceNotat";
import {NotatType} from "../../../core/sharedmodels/notat/notatType";
import {
    LaegekompetenceStatusEnum,
    LaegekompetenceStatusEnumTranslator
} from "../../../core/sharedmodels/kompetence/laegekompetenceStatusEnum";
import {Loading} from "../../../core/components/loading/loading";
import useLogbogApi from "core/hooks/useLogbogApi";
import {Dropdown} from "core/components/dropdown/dropdown";
import useEnumDropdownOptions from "core/components/dropdown/hooks/useEnumDropdownOptions";
import useUser from "core/hooks/useUser";
import {KompetenceListViewTypeEnum} from "../../../core/sharedmodels/kompetence/kompetenceListViewTypeEnum";
import useScreenResolution from "core/hooks/useScreenResolution";
import classNames from "classnames";
import useKompetenceCardListCategories from "./useKompetenceCardListCategories";
import { createPortal } from "react-dom";

export class KompetenceCardCategory {
    title: string;
    catagoryEnum: KompetenceCatagory;
    laegekompetencer: LaegekompetenceMeta[];
    expandByDefault: boolean;
    id?: string;
}

export enum KompetenceCatagory {
    OevrigeKompetencer = 0,
    KompetencerOnForloeb = 1,
    Klarmeldinger = 2,
    Foraeldede = 3
}

export enum KompetenceCardListType {
    KompetencerByBruger = 0,
    KlarmeldteKompetencerByVejleder = 1
}

export type KompetenceCardListProps = {
    kompetenceListType: KompetenceCardListType;
    selectedBrugerMaalbeskrivelseId?: string;
    customSearchPlaceholder?: string;
    customModileSearchPlaceholder?: string;
    getAllRegardlessOfMaalbeskrivelse?: boolean;
    disableFileCount?: boolean;
    mobileView?: boolean;
    showCompactView?: boolean;
}

const createLaegekompetencerNotatMultipleModalTarget = "kompetencenotat-multiple-kompetencer-create-modal";
const givMeritmModalTarget = "giv-merit-modal";

export const KompetenceCardList = ({
    disableFileCount=false,
    mobileView = false,
    showCompactView = false,
    ...props
}: KompetenceCardListProps) => {
    const location = useLocation<{ planlaeg: boolean }>();
    const dispatch = useAppDispatch();
    const { isMobile } = useScreenResolution();

    const { logbogLaegeKompetenceApi } = useLogbogApi();
    const { currentUser } = useUser();

    const forloebSliceState = useAppSelector(forloebReducer) as ForloebSliceState;
    const kompetenceCardState = useAppSelector(kompetenceCardReducer) as KompetenceCardState;

    const [laegekompetenceMetaState, setLaegekompetenceMetaState] = useState<LaegekompetenceMetaState[]>([])

    const [selectionActiveState, setSelectionActiveState] = useState<boolean>(false)
    const [planlaegActiveState, setPlanlaegActiveState] = useState<boolean>(false)
    const [givMeritActiveState, setGivMeritActiveState] = useState<boolean>(false)
    const [openMeritModal, setOpenMeritModal] = useState<boolean>(false)
    const [planlaegHistoryState, setPlanlaegHistoryState] = useState<boolean>(location?.state?.planlaeg ?? false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [searchParam, setSearchParam] = useState<string>();
    const [kompetenceStatus, setKompetenceStatus] = useState<LaegekompetenceStatusEnum>();
    const [kompetencestatusTypeDropdownOptions] = useEnumDropdownOptions<LaegekompetenceStatusEnum>(LaegekompetenceStatusEnum, LaegekompetenceStatusEnumTranslator);
    const [kompetenceListViewType, setKompetenceListViewType] = useState<KompetenceListViewTypeEnum>(KompetenceListViewTypeEnum.Planlagt);

    const isCurrentForloebBrugerMaalbeskrivelseSelected = forloebSliceState.forloebState.brugerMaalbeskrivelseId === props.selectedBrugerMaalbeskrivelseId;

    const isBrugerKompetencerList = props.kompetenceListType === KompetenceCardListType.KompetencerByBruger;
    const isKlarmeldingerKompetenceList = props.kompetenceListType === KompetenceCardListType.KlarmeldteKompetencerByVejleder;

    const useMobileView = mobileView || isMobile;
    const useCompactView = showCompactView && !isMobile;

    useEffect(() => {
        const cleanupOnUnmount = () => {
            dispatch(clearSelectedLaegekompetenceMetas());
            dispatch(setKompetenceCardStateShowCheckboxes([]));
        }
        return cleanupOnUnmount;
    }, [dispatch])

    const resetSelectionState = useCallback(() => {
        dispatch(clearSelectedLaegekompetenceMetas())
        dispatch(setKompetenceCardStateShowCheckboxes([]))
        setSelectionActiveState(false);
        setPlanlaegActiveState(false);
        setGivMeritActiveState(false);
    }, [dispatch]);

    useEffect(() => {
    if (!planlaegHistoryState) {
        resetSelectionState(); // refreshPing could indidcate, that a "selection operation" is finished, therefore reset the selection.
    }
    // Note: Listen on refresh-ping, for doing specific operations (when refreshing from other components). In future, we should not use this.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [kompetenceCardState.laegekompetenceListRefreshPing])

    const {
        laegeKompetencerTotalCount,
        laegeKompetenceCategories,
        laegeKompetenceCategoriesFiltered,
        kompetenceIdsAndFileCounts,
        isLoading,
        patchLaegeKompetencer,
    } = useKompetenceCardListCategories({
        options: {
            disableFileCount,
            kompetenceCardListType: props.kompetenceListType,
            kompetenceListViewType,
            // Note: Right now we use this refresh-ping for updating list (from many places). In future, we should patch the state instead.
            refreshOnChange: kompetenceCardState.laegekompetenceListRefreshPing
        },
        filter: {
            kompetenceStatus,
            searchParam
        },
        forloebState: forloebSliceState.forloebState,
        selectedBrugerMaalbeskrivelseId: props.selectedBrugerMaalbeskrivelseId,
        activeLaegeKompetenceId: kompetenceCardState.activeLaegekompetenceMeta.laegekompetenceId
    });

    const onLaegekompetenceCardFavoriteToggles = (laegekompetence: LaegekompetenceMeta) => {
        patchLaegeKompetencer(laegekompetence);
    }

    // Selection (Process More):

    const onToggleProcessMore = () => {
        const alleLaegekompetencerIds = laegeKompetenceCategories.flatMap(x => x.laegekompetencer).map(x => x.laegekompetenceId);
        dispatch(setKompetenceCardStateShowCheckboxes(alleLaegekompetencerIds));
        dispatch(clearSelectedLaegekompetenceMetas())
        setSelectionActiveState(true);
    }

    const onCreateLaegekompetenceNotatClicked = () => {
        dispatch(setSlideinState({state: SlideInStateEnum.Opened, slideInId: createLaegekompetencerNotatMultipleModalTarget}))
    }

    const onCreateNotatMultipleSlideInFinishedCallback = () => {
        dispatch(toggleLaegekompetenceNotatChangedPing()); // Make sure we update notat-tab (in case we have created notat on active-laegeKompetence)
        dispatch(toggleLaegekompetenceListRefreshPing()); //Was inside "CreateLaegeKompetenceNotat" before (now just here) - todo: remove it, when we can patch the state.
    }

    const onStatusActionSucceeded = (updatedLaegeKompetencer: LaegekompetenceMeta[]) => {
        patchLaegeKompetencer(updatedLaegeKompetencer);
        resetSelectionState();
    }

    // Planlaegning:

    const togglePlanlaeg = useCallback(() => {
        const alleKompetencer = laegeKompetenceCategories.map(lkc => lkc.laegekompetencer.map(lk => lk.laegekompetenceId)).flat();
        if (alleKompetencer.length > 0) {
            dispatch(setKompetenceCardStateShowCheckboxes(alleKompetencer));

            const laegekompetencerOnForloeb = laegeKompetenceCategories
                .find(lkc => lkc.catagoryEnum === KompetenceCatagory.KompetencerOnForloeb)?.laegekompetencer
                .map(lk => lk.ToState());

            dispatch(clearSelectedLaegekompetenceMetas(laegekompetencerOnForloeb));
            setPlanlaegActiveState(true);
            setPlanlaegHistoryState(false);
        }
    }, [dispatch, laegeKompetenceCategories])

    useEffect(() => {
        if (planlaegHistoryState) {
            togglePlanlaeg();
        }
    }, [planlaegHistoryState, togglePlanlaeg])

    const onPlanlaegSaveClicked = async () => {
        const chosenKompetencer = kompetenceCardState.selectedLaegekompetenceMetas;
        const chosenLaegeKompetenceIds = chosenKompetencer.map(lk => lk.laegekompetenceId);

        const updatedForloeb = await logbogLaegeKompetenceApi.updateKompetencerOnForloeb(forloebSliceState.forloebState.id, chosenLaegeKompetenceIds);
        if (updatedForloeb) {
            resetSelectionState();

            // Patch laegeKompetencer:

            const updatedLaegeKompetencerOnForloeb = chosenKompetencer
                .map(lk => ({...lk, forloebIds: [...lk.forloebIds, forloebSliceState.forloebState.id]}))
                .map(lk => LaegekompetenceMeta.FromState(lk, forloebSliceState.forloebState));

            const updatedLaegeKompetencerNotOnForloeb = laegeKompetenceCategories
                .flatMap(x => x.laegekompetencer)
                .filter(x => !chosenLaegeKompetenceIds.includes(x.laegekompetenceId))
                .map(x => x.ToState())
                .map(lk => ({...lk, forloebIds: [...lk.forloebIds.filter(id => id !== forloebSliceState.forloebState.id)]}))
                .map(lk => LaegekompetenceMeta.FromState(lk, forloebSliceState.forloebState));

            const updatedLaegeKompetencer = [...updatedLaegeKompetencerOnForloeb, ...updatedLaegeKompetencerNotOnForloeb];

            patchLaegeKompetencer(updatedLaegeKompetencer);

            NotificationModule.showSuccess(Localizer.kompetencerPage_forloebskompetencerEditted(), "");
        }
    }

    // Giv Merit:

    const onToggleGivMerit = () => {
        const alleIkkeGodkendteKompetencer = laegeKompetenceCategories
            .filter(lkc => lkc.catagoryEnum !== KompetenceCatagory.Foraeldede)
            .flatMap(lkc => lkc.laegekompetencer)
            .filter(lk => lk.status !== LaegekompetenceStatusEnum.Godkendt)
            .map(lk => lk.laegekompetenceId);

        dispatch(setKompetenceCardStateShowCheckboxes(alleIkkeGodkendteKompetencer));
        dispatch(clearSelectedLaegekompetenceMetas())
        setGivMeritActiveState(true);
    }

    const onGivMeritClicked = async () => {
        const chosenKompetencer = kompetenceCardState.selectedLaegekompetenceMetas;
        setLaegekompetenceMetaState(chosenKompetencer);
        setOpenMeritModal(true);
    }

    const onGivMeritModalSucceded = async () => {
        const updatedLaegeKompetencer = kompetenceCardState.selectedLaegekompetenceMetas
            .map(lk => ({...lk, status: LaegekompetenceStatusEnum.Godkendt, notatCount: lk.notatCount + 1}))
            .map(lk => LaegekompetenceMeta.FromState(lk, forloebSliceState.forloebState));

        const result = await logbogLaegeKompetenceApi.patchStatusMultiple(updatedLaegeKompetencer);

        if(result.length > 0) {
            resetSelectionState();
            patchLaegeKompetencer(updatedLaegeKompetencer);
        }
    }

    const noKompetencer = laegeKompetencerTotalCount <= 0;
    const emptyListText = isBrugerKompetencerList ? Localizer.kompetencePage_noKompetencer() : Localizer.klarmeldingerPage_noKlarmeldinger();

    return (
        <div className="div-style card-list-custom style body-flex">
            <Loading
                isLoading={isLoading}
                //if there is no kompetencer initially: show loading as soon as possible:
                timeout={noKompetencer ? 0 : 1000}
                text={Localizer.kompetencePage_getKompetencer()}
                emptyText={noKompetencer ? emptyListText : ""}
                spinnerClasses="margin-m"
                >
                {selectionActiveState &&
                    <div className="card-body d-flex flex-column flex-space-around card-list-custom body-flex">
                        <div className="d-flex wrap flex-space-around">
                            <button type="button" className="btn btn-default"
                                    onClick={resetSelectionState}>
                                {Localizer.global_fortryd()}
                            </button>
                            {!currentUser.IsSekretaer() &&
                                <button className="btn btn-default" onClick={onCreateLaegekompetenceNotatClicked} data-toggle="modal"
                                        data-target={`#${createLaegekompetencerNotatMultipleModalTarget}`}
                                        disabled={((kompetenceCardState.showCheckboxOnIds.length > 0 && (kompetenceCardState.selectedLaegekompetenceMetas.length === 0)) || kompetenceCardState.selectedLaegekompetenceMetas.filter(lk => lk.godkendtDato !== undefined).length > 0 )}>
                                    <EmblaIcon iconName="document"/>
                                    {Localizer.notatPage_createNotat()}
                                </button>
                            }
                            <KompetenceStatusButton
                                buttonHandleCallback={godkender => setShowSpinner(godkender)}
                                onSucceded={onStatusActionSucceeded}
                                brugerId={kompetenceCardState.activeLaegekompetenceMeta.UserId}
                            />
                        </div>
                    </div>
                }

                {planlaegActiveState &&
                    <div className="card-body flex-space-around card-list-custom body-flex">
                        <p className="">{Localizer.kompetencePage_chooseKompetencer()}</p>
                        <div>
                            <button type="button" className="btn btn-default margin-top-s margin-right-s"
                                    onClick={resetSelectionState}>
                                {Localizer.global_fortryd()}
                            </button>
                            <button type="button" className="btn btn-primary margin-top-s"
                                    onClick={onPlanlaegSaveClicked}>
                                {Localizer.global_save()}
                            </button>
                        </div>
                    </div>
                }

                {givMeritActiveState &&
                    <div className="card-body flex-space-around card-list-custom body-flex">
                        <div>
                            <button type="button" className="btn btn-default"
                                    onClick={resetSelectionState}>
                                {Localizer.global_fortryd()}
                            </button>
                            <button type="button" className="btn btn-primary margin-left-s"
                                    disabled={kompetenceCardState.showCheckboxOnIds.length > 0 && kompetenceCardState.selectedLaegekompetenceMetas.length === 0}
                                    onClick={onGivMeritClicked}>
                                {Localizer.kompetencePage_givMerit()}
                            </button>
                        </div>
                    </div>
                }
                <div className="card-body flex-container-column card-list-custom body-flex">
                    {!selectionActiveState && !planlaegActiveState && !givMeritActiveState && (isCurrentForloebBrugerMaalbeskrivelseSelected || isKlarmeldingerKompetenceList) && !currentUser.IsKonsulentForLaegeligVidereuddannelse() &&
                        <div className="flex-container wrap flex-space">
                            {!currentUser.IsSekretaer() &&
                                <div className="margin-bottom-s">
                                    <button type="button" className="btn btn-default margin-right-s"
                                            onClick={onToggleProcessMore}>
                                        {Localizer.global_chooseMultiple()}
                                    </button>
                                    {currentUser.IsLaege() &&
                                        <button type="button"
                                                className="btn btn-default text-truncate margin-right-s"
                                                onClick={togglePlanlaeg}>
                                            {Localizer.kompetencePage_planlaegKompetencer()}
                                        </button>
                                    }
                                    {currentUser.IsAdminOrVus() &&
                                        <button type="button" className="btn btn-default margin-right-s"
                                                onClick={onToggleGivMerit}>
                                            {Localizer.kompetencePage_givMerit()}
                                        </button>
                                    }
                                </div>
                            }
                            {(currentUser.IsAdminOrVus() || currentUser.IsVejleder() || currentUser.IsUddannelsesansvarlig()) && !isKlarmeldingerKompetenceList &&
                                <div className={classNames("btn-group")}>
                                    <button type="button"
                                            className={`btn ${kompetenceListViewType === KompetenceListViewTypeEnum.Planlagt ? "btn-primary" : "btn-default"}`}
                                            aria-label="Left"
                                            onClick={() => setKompetenceListViewType(KompetenceListViewTypeEnum.Planlagt)}>
                                        {Localizer.global_planlagt()}
                                    </button>
                                    <button type="button"
                                            className={`btn ${kompetenceListViewType === KompetenceListViewTypeEnum.Standard ? "btn-primary" : "btn-default"}`}
                                            aria-label="Right"
                                            onClick={() => setKompetenceListViewType(KompetenceListViewTypeEnum.Standard)}>
                                        {Localizer.global_standard()}
                                    </button>
                                </div>
                            }
                        </div>
                    }
                    <div className={`d-flex wrap ${isMobile ? "flex-container-column" : ""}`}>
                        {isBrugerKompetencerList &&
                            <div className={"min-w-150 margin-right-s margin-top-s"}>
                                <Dropdown
                                    placeholder={Localizer.global_all()}
                                    options={kompetencestatusTypeDropdownOptions}
                                    onChange={(selectedOption) => setKompetenceStatus(selectedOption?.value)}
                                    isClearable
                                />
                            </div>
                        }
                        <div className={`flex-grow input-icon-container ${isMobile ? "margin-right-s" : ""}`}>
                            <input className="form-control margin-top-s"
                                   onChange={(event) => setSearchParam(event.currentTarget.value)}
                                   value={searchParam}
                                   placeholder={isMobile ? props.customModileSearchPlaceholder ?? Localizer.klarmeldingerPage_searchStringMobile() : props.customSearchPlaceholder ?? Localizer.klarmeldingerPage_searchString()}/>
                            <div className="input-icon margin-top-s">
                                <EmblaIcon iconName="search"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-body padding-0 card-list-scroll position-relative"
                    role="tabpanel"
                    key={laegeKompetenceCategoriesFiltered.map(lkc => lkc.laegekompetencer.map(lk => lk.laegekompetenceId + lk.status + lk.notatCount)).flat().join() + givMeritActiveState}>
                    {
                        laegeKompetenceCategoriesFiltered
                            .filter(lk => lk.catagoryEnum !== KompetenceCatagory.Foraeldede || (lk.catagoryEnum === KompetenceCatagory.Foraeldede && givMeritActiveState))
                            .map((kompetenceCatagory, index) =>
                                <CollapseTab
                                    key={KompetenceCatagory[kompetenceCatagory.catagoryEnum]}
                                    collapseHeaderType={kompetenceCatagory.catagoryEnum === KompetenceCatagory.KompetencerOnForloeb
                                        ? CollapseHeaderTypeEnum.Primary
                                        : kompetenceCatagory.catagoryEnum === KompetenceCatagory.OevrigeKompetencer
                                            ? CollapseHeaderTypeEnum.Secondary
                                            : CollapseHeaderTypeEnum.Default}
                                    id={KompetenceCatagory[kompetenceCatagory.catagoryEnum] + kompetenceCatagory?.id}
                                    expandedDefault={kompetenceCatagory.expandByDefault}
                                    categoryEnum={kompetenceCatagory.catagoryEnum}
                                    additionalClasses={classNames(kompetenceCatagory.catagoryEnum === KompetenceCatagory.KompetencerOnForloeb && "border-collapse-primary")}
                                    title={selectionActiveState
                                        ? kompetenceCatagory.title + ` (${kompetenceCatagory.laegekompetencer.length}/${laegeKompetenceCategories[index].laegekompetencer.length}) - ${laegeKompetenceCategories[index].laegekompetencer.filter(k => kompetenceCardState.selectedLaegekompetenceMetas.flatMap(k => k.laegekompetenceId).includes(k.laegekompetenceId)).length} valgt`
                                        : kompetenceCatagory.title + ` (${kompetenceCatagory.laegekompetencer.length})`}
                                    >
                                    {
                                        <div className={classNames(kompetenceCatagory.catagoryEnum === KompetenceCatagory.KompetencerOnForloeb && "border-collapse-primary")}>
                                            {kompetenceCatagory.laegekompetencer.map((laegekompetence) =>
                                                <KompetenceCard
                                                    key={laegekompetence.laegekompetenceId + laegekompetence.status?.toString() + laegekompetence.notatCount}
                                                    laegekompetence={laegekompetence}
                                                    mobileView={useMobileView}
                                                    index={laegekompetence.laegekompetenceId}
                                                    kompetenceListType={props.kompetenceListType}
                                                    onFavoriteToggleCallback={onLaegekompetenceCardFavoriteToggles}
                                                    showSpinner={showSpinner}
                                                    kompetenceCategory={kompetenceCatagory.catagoryEnum}
                                                    regionId={forloebSliceState.forloebState.regionId}
                                                    amountFiles={kompetenceIdsAndFileCounts.find(x => x.id === laegekompetence.kompetenceId)?.count}
                                                    showCompactView={useCompactView}
                                                />
                                            )}
                                        </div>
                                    }
                                </CollapseTab>
                            )
                    }
                </div>
                {openMeritModal && laegekompetenceMetaState.length > 0 &&
                    <SlideIn
                        id={givMeritmModalTarget}
                        defaultOpen={true}
                        title={Localizer.notatPage_meritNotat()}
                        actionText={Localizer.notatPage_creatingNotat()}
                        bodyContent={
                            <CreateLaegekompetenceNotat 
                                modalId={givMeritmModalTarget}
                                laegekompetencer={laegekompetenceMetaState.filter(l => l.status !== LaegekompetenceStatusEnum.Godkendt).map(lk => LaegekompetenceMeta.FromState(lk, forloebSliceState.forloebState))}
                                notatType={NotatType.Merit}
                                titel={Localizer.notatPage_meritNotat()}
                            />
                        }
                        actionFinishedCallback={() => onGivMeritModalSucceded()}
                        actionOnCloseCallback={() => setOpenMeritModal(false)}
                    />
                }
                {createPortal(
                    <SlideIn
                        id={createLaegekompetencerNotatMultipleModalTarget}
                        title={Localizer.notatPage_createNotat()}
                        actionText={Localizer.notatPage_creatingNotat()}
                        bodyContent={
                            <CreateLaegekompetenceNotat 
                                modalId={createLaegekompetencerNotatMultipleModalTarget} 
                                laegekompetencer={kompetenceCardState.selectedLaegekompetenceMetas.map(lkm => LaegekompetenceMeta.FromState(lkm, forloebSliceState.forloebState))} 
                                notatType={NotatType.Kompetence}
                            />
                        }
                        actionFinishedCallback={onCreateNotatMultipleSlideInFinishedCallback}
                    />,
                    document.body
                )}
            </Loading>
        </div>
    );
}
